import DefaultPopup, { IDefaultPopup } from '../defaultPopup';

import * as ST from './styled';

export enum EResultPopupStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    DEFAULT = 'default',
}

const resultIconTypes = {
    [EResultPopupStatus.SUCCESS]: {
        iconPath: require('../../../assets/img/icons/statuses/popup/success.svg'),
        iconAlt: 'Успех',
    },
    [EResultPopupStatus.ERROR]: {
        iconPath: require('../../../assets/img/icons/statuses/popup/error.svg'),
        iconAlt: 'Ошибка',
    },
    [EResultPopupStatus.WARNING]: {
        iconPath: require('../../../assets/img/icons/statuses/popup/warning.svg'),
        iconAlt: 'Предупреждение',
    },
    [EResultPopupStatus.DEFAULT]: {
        iconPath: '',
        iconAlt: '',
    },
};

export interface IProps extends IDefaultPopup {
    title?: React.ReactNode | string | null,
    text?: React.ReactNode | string | null,
    type?: EResultPopupStatus,
    children?: React.ReactNode | string | null,
}

const PopupResult = ({
    title,
    text,
    type = EResultPopupStatus.DEFAULT,
    children,
    ...props
}: IProps) => {
    const isTitleString = typeof title === 'string';
    const isTextString = typeof text === 'string';

    const { iconPath, iconAlt } = resultIconTypes[type || EResultPopupStatus.DEFAULT];

    return (
        <DefaultPopup {...props}>
            <ST.Container>
                {!!iconPath && (
                    <ST.Icon
                        src={iconPath}
                        alt={iconAlt}
                        data-test='popup-result-icon'
                    />
                )}
                {title &&
                    <ST.Title isIcon={!!iconPath} data-test='popup-result-title'>
                        {isTitleString
                            ? <p>{title}</p>
                            : title
                        }
                    </ST.Title>
                }
                {text &&
                    <ST.Text data-test='popup-result-text'>
                        {isTextString
                            ? <p>{text}</p>
                            : text
                        }
                    </ST.Text>
                }
                {children &&
                    <ST.Content>{children}</ST.Content>
                }
            </ST.Container>
        </DefaultPopup>
    );
};

export default PopupResult;
